var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-table',{ref:"table",attrs:{"caption":"Orders","columns":_vm.columns,"actions":_vm.tableActions,"url":"orders","params":_vm.tableParams}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }